import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {tap} from 'rxjs/operators';
import {NotiFilters} from '../../../views/wrapper/payroll/notification/notifications/notifications';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notificationSubject = new BehaviorSubject<any>(null);
  newRequestSubject = new BehaviorSubject<boolean>(false);
  private isLoading = false;
  hasNewNotification: any = {};
  resetNotification = false;
  resetNewRequest = false;
  newRequest = false;
  totalSubject = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient
  ) {
  }

  getTotalNoti(companyId: string, status: string, year: string): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/companies/${companyId}/notification/listnumber/${status}` + (year ? `?year=${year}`: '')).pipe(
      tap(() => {
        this.getAlertNotification(companyId, status, year);
      })
    );
  }

  getNotiList(body: any, year: string): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/companies/${body.companyId}/notification` + (year ? `?year=${year}`: ''), body);
  }

  submitNotification(body: any, year: string): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/companies/${body.companyId}/notification/${body.notiId}`, body).pipe(
      tap(() => {
        this.resetNotification = true;
        this.resetNewRequest = true;
        this.getAlertNotification(body.companyId, NotiFilters.waiting, year);
        this.checkHasNewRequested(body.companyId, NotiFilters.waiting, year);
      })
    );
  }

  getAlertNotification(companyId: string, status: string, year: string): BehaviorSubject<null> {
    if (year) {
      if (this.hasNewNotification[year] && !this.resetNotification) {
        this.notificationSubject.next(this.hasNewNotification[year]);
      } else if (!this.isLoading || this.resetNotification) {
        this.isLoading = true;
        this.getTotalNoti(companyId, status, year).subscribe((resp) => {
            this.hasNewNotification[year] = resp.data;
            this.isLoading = false;
            this.resetNotification = false;
            this.notificationSubject.next(this.hasNewNotification[year]);
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
            this.resetNotification = false;
            this.notificationSubject.next(null);
          });
        return this.notificationSubject;
      }
    } else {
      return this.notificationSubject;
    }
  }

  checkHasNewRequested(companyId: string, status: string, year: string): BehaviorSubject<boolean> {
    if (this.newRequest && !this.resetNewRequest) {
      this.newRequestSubject.next(this.newRequest);
    } else if (!this.isLoading || this.resetNewRequest) {
      this.isLoading = true;
      this.getTotalNoti(companyId, status, year).subscribe((resp) => {
          this.newRequest = resp.data.number_requests_all > 0;
          this.isLoading = false;
          this.resetNewRequest = false;
          this.newRequestSubject.next(this.newRequest);
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
          this.resetNewRequest = false;
          this.newRequestSubject.next(false);
        });
      return this.newRequestSubject;
    }
    return this.newRequestSubject;
  }

  voidNoti(companyId: string, notificationId: string): Observable<any> {
    return this.http.delete(`${environment.apiBaseUrl}/companies/${companyId}/notification/${notificationId}`);
  }

  submitSelfOnboardNotification(body: any): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/companies/${body.companyId}/notification/${body.notiId}`, body);
  }

  submitMultiSelfOnboardNotifications(body: any): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/companies/${body.companyId}/notification/self-onboarding/submit-multiple`, body);
  }

  getSelfOnboardNotification(companyId: string, empId: string): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/companies/${companyId}/notification?info_type=personal_info_self_onboarding&status=waiting` + (empId ? `&employee_id=${empId}`: ''));
  }

  triggetTotalSubject() {
    this.totalSubject.next(new Date().getTime());
    return this.totalSubject;
  }
}
